export const SPECIAL_REDIRECT = 'redirect-to-the-first-available';
